import React, { useEffect, useState } from 'react';
import $ from "jquery";
import './App.scss';
import { Switch, Route, useLocation } from "react-router-dom";
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
// React 19: react-lottie removed (uses findDOMNode which was dropped in React 19).
// Replaced with lottie-react which uses a modern ref-based API.
import Lottie from 'lottie-react';
import loaderAnimation from './assets/animation/js-loader.json';
import ReactGA from 'react-ga';
import loadable from '@loadable/component'
import { ParallaxProvider } from 'react-scroll-parallax';
import SmoothScroll from './Components/SmoothScroll'
const Home = loadable(() => import('./Components/Home'));
const Branches = loadable(() => import('./Components/Branches'));
const Contact_us = loadable(() => import('./Components/Contact_us'));
const Products = loadable(() => import('./Components/Products'));
ReactGA.initialize('UA-163765436-1');

// Replaces google.maps.places opening_hours.isOpen() — works with the same
// { periods: [7 day objects] } JSON shape stored in Strapi.
function isOpenNow(periods) {
  if (!periods) return false;
  const now = new Date();
  const t = now.getHours() * 100 + now.getMinutes();
  const p = periods[now.getDay()];
  if (!p) return false;
  const o = parseInt(p.open.time, 10), c = parseInt(p.close.time, 10);
  return c < o ? t >= o || t < c : t >= o && t < c;
}

function App() {
  let location = useLocation();

  ReactGA.pageview(location.pathname);

  const fiexdContent = {
    en: {
      nav: ['Home',
        'Branches',
        'Products', 'Contact us', '0502662288'],
      footer: [],
    },
    ar: {
      nav: ['الرئيسية'
        , 'فروعنا'
        , 'منتجاتنا', 'تواصل معنا', '٠٥٠٢٦٦٢٢٨٨'],
      footer: [],
    }
  }
  const [home, setHome] = useState({});
  const [actvieNav, setActiveNav] = useState(fiexdContent.en.nav);
  const [isArabic, setIsArabic] = useState(true);
  const [menuSubCategory, setMenuSubCategory] = useState(null);
  const [menuCategory, setMenuCategory] = useState(null);
  const [items, setItems] = useState(null);
  const [subCategoryByMain, setSubCategoryByMain] = useState(null);
  const [contactUs, setContactUs] = useState(null);
  const [branches, setBranches] = useState([])
  const [isCallAPIDone, setIsCallAPIDone] = useState(false)
  const [isLoaderDone, setIsLoaderDone] = useState(false)

  // Fallback: if Lottie fails to render (e.g. headless browsers, blocked canvas),
  // force-show the app after 4 seconds so the page is never permanently stuck.
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaderDone(true), 4000);
    return () => clearTimeout(timer);
  }, [])

  useEffect(() => {
    var browser = 'unknown';
    var ua = navigator.userAgent;
    if ((ua.indexOf("Opera") || ua.indexOf('OPR')) !== -1) {
      browser = 'Opera'
    }
    else if (ua.indexOf("Edge") !== -1) {
      browser = 'Edge'
    }
    else if (ua.indexOf("Chrome") !== -1) {
      browser = 'Chrome'
    }
    else if (ua.indexOf("Safari") !== -1) {
      browser = 'Safari'
    }
    else if (ua.indexOf("Firefox") !== -1) {
      browser = 'Firefox'
    }
    else if ((ua.indexOf("MSIE") !== -1) || (!!document.documentMode === true)) //IF IE > 10
    {
      browser = 'IE'
    }
    else {
      browser = 'unknown'
    }

    (browser === 'Chrome' || browser === 'Opera' || browser === 'Firefox') ? $('body').addClass('webp') : $('body').addClass('jp2')

    new SmoothScroll(document, 80, 14)

  }, [])

  useEffect(() => {

    const API_KEY = process.env.REACT_APP_STRAPI_TOKEN;
    const url = process.env.REACT_APP_STRAPI_URL;
    const headers = { 'Authorization': `Bearer ${API_KEY}` };

    // home (single type — returns object, not array)
    fetch(`${url}/api/home?populate=*`, { method: 'GET', headers })
      .then(res => res.json())
      .then(res => { if (res.data) setHome(res.data) })

    // items
    fetch(`${url}/api/items?populate=*&pagination[limit]=500`, { method: 'GET', headers })
      .then(res => res.json())
      .then(res => { setItems(res.data) })

    // menu-categories
    fetch(`${url}/api/menu-categories?populate=*&pagination[limit]=500&sort[0]=id:asc`, { method: 'GET', headers })
      .then(res => res.json())
      .then(res => { setMenuCategory(res.data) })

    // menu-sub-categories
    fetch(`${url}/api/menu-sub-categories?populate=*&pagination[limit]=500&sort[0]=id:asc`, { method: 'GET', headers })
      .then(res => res.json())
      .then(res => { setMenuSubCategory(res.data) })

    // contact (single type — returns object, not array)
    fetch(`${url}/api/contact?populate=*`, { method: 'GET', headers })
      .then(res => res.json())
      .then(res => { if (res.data) setContactUs(res.data) })

    // branches — data + isOpen class computed inline, no Places API needed
    fetch(`${url}/api/branches?filters[status][$eq]=published&populate=*&pagination[limit]=500`, { method: 'GET', headers })
      .then(res => res.json())
      .then(res => {
        const enriched = (res.data || []).map(b => ({
          ...b,
          types: b.types || [],
          class: [...(b.types || []), ...(isOpenNow(b.opening_hours?.periods) ? ['open'] : [])]
        }));
        setBranches(enriched);
        setIsCallAPIDone(true);
      })
  }, [])


  useEffect(() => {
    if (menuCategory && menuSubCategory) {
      getAllitemsByMaincategory();
    }
  }, [menuCategory, menuSubCategory])

  const getAllitemsByMaincategory = () => {
    let getSubCategoryByMain = menuCategory.map((category) => {
      let subcategoryIds = [];
      let subcategoryObjects = [];
      menuSubCategory.forEach((subcategory) => {
        // Strapi returns relations as objects when populate=* is used
        const catId = subcategory.category?.id ?? subcategory.category;
        if (catId === category.id) {
          subcategoryIds.push(subcategory.id);
          subcategoryObjects.push(subcategory);
        }
      })
      return {
        category_id: category.id,
        category_ar_name: category.ar_name,
        category_en_name: category.en_name,
        sub_category: subcategoryIds,
        sub_category_objects: subcategoryObjects,
        image: category.image  // Strapi inline media object { url, ... }
      }
    })
    setSubCategoryByMain(getSubCategoryByMain)
  }

  useEffect(() => {
    if (isArabic) {
      setActiveNav(fiexdContent.ar.nav);
      $('body').addClass('ar')
    } else {
      setActiveNav(fiexdContent.en.nav)
      $('body').removeClass('ar')
    }
  }, [isArabic])

  const isOpen = (branche, isHomePage) => {
    if (!branche.opening_hours?.periods) return null;
    var now = new Date();
    let dayNumber = now.getDay();
    const todayPeriod = branche.opening_hours.periods[dayNumber];
    if (!todayPeriod) return isHomePage
      ? <div><span className="closed pr-1">{isArabic ? 'مغلق' : 'Closed'}</span></div>
      : <p className="m-0"><span>{isArabic ? 'مغلق' : 'Closed'}</span></p>;

    let close = todayPeriod.close.time;
    let open = todayPeriod.open.time;

    let isAM_close = null;
    let isAM_open = null;

    if (parseInt(close[0] + close[1]) > 12) {
      isAM_close = (isArabic) ? 'مساءً' : 'PM'
    } else {
      isAM_close = (isArabic) ? 'صباحاً' : 'AM'
    }

    if (parseInt(open[0] + open[1]) > 12) {
      isAM_open = (isArabic) ? 'مساءً' : 'PM'
    } else {
      isAM_open = (isArabic) ? 'صباحاً' : 'AM'
    }
    close = (parseInt(close[0] + close[1]) % 12 || 12).toString() + ":" + close[2] + close[3] + " " + isAM_close
    open = (parseInt(open[0] + open[1]) % 12 || 12).toString() + ":" + open[2] + open[3] + " " + isAM_open

    if (isOpenNow(branche.opening_hours.periods)) {
      return (isHomePage) ?
        <div className="">
          <span className="open pr-1">{(isArabic) ? 'مفتوح' : 'Open'} </span><span className="open-hours">{open} - {close}</span>
        </div>
        :
        <p className="m-0"><span className="open-now">{(isArabic) ? ' مفتوح الآن' : 'Open now'}</span> {(isArabic) ? 'إلى ' : 'till '}{close}</p>
    } else {
      return (isHomePage) ?
        <div className="">
          <span className="closed pr-1">{(isArabic) ? 'مغلق' : 'Closed'} </span><span className="open-hours">{open} - {close}</span>
        </div>
        :
        <p className="m-0"><span className="">{(isArabic) ? 'مغلق' : 'Closed'} </span>{open} - {close}</p>
    }

  }

  return (
    <React.Fragment>
      <div className="loader bg-dust">
        <div>
          {/* lottie-react replaces react-lottie: direct props instead of options object */}
          <Lottie
            animationData={loaderAnimation}
            loop={false}
            autoplay={true}
            onComplete={() => {
              setIsLoaderDone(true);
              $('.loader').addClass('none').css('z-index', '-14');
              $('body').css('overflow', 'auto');
            }}
            onEnterFrame={() => $('body').css('overflow', 'hidden')}
          />
        </div>
      </div>
      {isLoaderDone &&
        <a
          href="https://wa.me/966502662288"
          className="whatsapp-float"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true">
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
          </svg>
        </a>
      }
      {isLoaderDone &&
        <main className="pt-lg-4">
          <Route>
            <Navbar
              path="/"
              fiexdContent={fiexdContent}
              actvieNav={actvieNav}
              isArabic={isArabic}
              setIsArabic={setIsArabic} />
          </Route>

          <Switch>
            <Route exact path="/">
              <ParallaxProvider>
                <Home
                  home={home}
                  menuCategory={menuCategory}
                  subCategoryByMain={subCategoryByMain}
                  items={items}
                  menuSubCategory={menuSubCategory}
                  isArabic={isArabic}
                  branches={branches}
                  isOpen={isOpen}
                />
              </ParallaxProvider>
            </Route>

            <Route exact path="/branches">
              <Branches
                isArabic={isArabic}
                branches={branches}
                isOpen={isOpen}
                isCallAPIDone={isCallAPIDone}
              />
            </Route>

            <Route exact path="/products" >
              <Products
                subCategoryByMain={subCategoryByMain}
                items={items}
                menuSubCategory={menuSubCategory}
                isArabic={isArabic}
              />
            </Route>

            <Route exact path="/contactus">
              <Contact_us
                contactUs={contactUs}
                isArabic={isArabic}
              />
            </Route>
          </Switch>
          <Route>
            <Footer
              path="/"
              fiexdContent={fiexdContent}
              actvieNav={actvieNav}
              isArabic={isArabic}
              setIsArabic={setIsArabic} />
          </Route>

        </main>
      }
    </React.Fragment>
  )
}

export default App;
